import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import {
  actualityAggregatedStatsGroupBy,
  actualityAggregatedStatsGroupBySecondary,
} from '../store/actuality.kpi.state';
import {
  ActualityAggregatedHqExtendedDataRow,
  ActualityAggregationField,
} from '../store/actuality.kpi.types';
import useActualityAggregationFieldDescriptors from './useActualityAggregationFieldDescriptors';

function useGetActualityAggregationGroupTitle() {
  const groupBy = useRecoilValue(actualityAggregatedStatsGroupBy);
  const subGroupBy = useRecoilValue(actualityAggregatedStatsGroupBySecondary);
  const aggFieldsDescriptors = useActualityAggregationFieldDescriptors();
  return (
    groupKey: Partial<ActualityAggregatedHqExtendedDataRow>,
    groupFields?: ActualityAggregationField[],
  ): string => {
    const fields = groupFields ?? [groupBy, subGroupBy];
    return _.map(fields, f => {
      const value = _.get(groupKey, f);
      return aggFieldsDescriptors[f]?.formatter?.(value) ?? value?.toString();
    }).join(' / ');
  };
}

export default useGetActualityAggregationGroupTitle;
